/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */

import React, { useRef, useState, useEffect } from 'react';
import customStyles from "../../../../assets/styles/customStyles";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../Icons/selectedIcon";
import { Image, Dropdown, Menu } from "antd";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import ReactApexChart from "react-apexcharts";
import { currencyFormatInt, quantityFormat, downloadImageCommon, exportChatFile } from "../../../../helpers/utilities";


export const SalesByProduct = (props) => {
    const { title, details, value, quantity, subTitle } = props;
    const [type, setType] = useState('value');
    const classes = customStyles();
    const [labels, setLabels] = useState([]);
    const [values, setValues] = useState([]);
    const [percentage, setPercentage] = useState([]);
    const [top10, setTop10] = useState([]);
    const SalesByProduct = useRef(null);

    useEffect(() => {
        let names = [];
        let values = []; let percentage = [];
        details?.length > 0 && details.sort((a, b) => parseFloat(b?.totalAmount || 0) - parseFloat(a?.totalAmount || 0)).slice(0, 10)?.map((detail) => {
            names.push(detail.productName);
            values.push(detail?.totalAmount || 0);
            percentage.push(detail?.amountPercentage || 0);
        });
        let total = details.sort((a, b) => parseFloat(b?.totalAmount || 0) - parseFloat(a?.totalAmount || 0)).slice(0, 10)?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.amountPercentage || 0)), 0);
        let totalTop10Amount = details.sort((a, b) => parseFloat(b?.totalAmount || 0) - parseFloat(a?.totalAmount || 0)).slice(0, 10)?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.totalAmount || 0)), 0);
        let totalAmount = details?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.totalAmount || 0)), 0);
        setTop10((total).toFixed(1));
        let otherValue = parseFloat(totalAmount - totalTop10Amount);
        names.push('Others');
        if (otherValue > 0) {
            values.push(parseFloat(totalAmount - totalTop10Amount));
            percentage.push(parseFloat(100 - total));
        } else {
            values.push(0);
            percentage.push(0);
        }
        setLabels(names);
        setValues(values);
        setPercentage(percentage);
    }, []);


    const handleType = (value) => {
        setType(value);
        let names = [];
        let values = []; let percentage = [];
        let v = value === 'value' ? 'totalAmount' : 'totalQuantity';
        let p = value === 'value' ? 'amountPercentage' : 'quantityPercentage';

        details?.length > 0 && details.sort((a, b) => b[v] - a[v]).slice(0, 10)?.map((detail) => {
            names.push(detail.productName);
            values.push(detail[v] || 0);
            percentage.push(detail[p] || 0);
        });
        let total = details.sort((a, b) => parseFloat(b[v] || 0) - parseFloat(a[v] || 0)).slice(0, 10)?.reduce((a, z) => a = parseFloat(parseFloat(a) + parseFloat(z[p] || 0)), 0);
        let totalTop10Amount = details.sort((a, b) => parseFloat(b[v] || 0) - parseFloat(a[v] || 0)).slice(0, 10)?.reduce((a, x) => a = parseFloat(parseFloat(a) + parseFloat(x[v] || 0)), 0);
        let totalAmount = details?.reduce((a, x) => a = parseFloat(parseFloat(a) + parseFloat(x[v] || 0)), 0);
        setTop10((total).toFixed(1));
        let otherValue = parseFloat(totalAmount - totalTop10Amount);
        names.push('Others');
        if (otherValue > 0) {
            values.push(parseFloat(totalAmount - totalTop10Amount));
            percentage.push(parseFloat(100 - total));
        } else {
            values.push(0);
            percentage.push(0);
        }
        setLabels(names);
        setValues(values); setPercentage(percentage);
    }

    const chartSalesProduct = {
        chart: {
            width: 500,
            type: 'pie',
            animations: {
                enabled: true,
            }
        },
        title: {
            text: 'Top 10 Products',
            margin: 0,
            offsetX: -10,
            floating: true,
            style: {
                fontSize: '13px',
                fontWeight: 'normal',
                fontFamily: 'Roboto',
                color: '#8a8a8e'
            },
        },
        subtitle: {
            text: 'Percentage',
            margin: 0,
            offsetX: -20,
            offsetY: 0,
            floating: true,
            align: "center",
            style: {
                fontSize: '13px',
                fontWeight: 'normal',
                fontFamily: 'Roboto',
                color: '#8a8a8e'
            },
        },
        labels: labels,
        colors: ['#88c6d3', '#307686', '#dbe8c5', '#afe3d0', '#7dbba9', '#fad6d3', '#f7959d', '#ff6b6b', '#ffc27a', '#1c314c', '#c1c8e3'],
        dataLabels: { enabled: false },
        legend: {
            fontFamily: "Roboto",
            formatter: function (seriesName, opts) {
                return seriesName + '<span  class="custom-marker">' + (percentage[opts?.seriesIndex] ? (percentage[opts?.seriesIndex])?.toFixed(1) : 0) + '%<span>';
            },
            height: "100%",
            position: 'left',
            itemMargin: {
                horizontal: 0,
                vertical: 6
            },
        },
        stroke: {
            width: 1,
            colors: ['#fff']
        },
        tooltip: {
            enabled: true,
            style: {
                fontSize: '10px',
                fontFamily: 'Roboto',
                fontWeight: 500,
            },
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const value = type === 'value' ? '<div class="invoices-amount">₹ ' + currencyFormatInt(series[seriesIndex]) + '</div>' : '<div class="invoices-amount">Quantity - ' + quantityFormat(series[seriesIndex]) + '</div>';
                return '<div class="arrow_box_clients">' +
                    '<div class="">' + w.globals.labels[seriesIndex] + '</div>' +
                    '<div class="invoices">' + (percentage[seriesIndex])?.toFixed(1) + ' %</div>' + value +
                    '</div>';
            }
        },
        plotOptions: {
            pie: {
                customScale: 0.9,
                expandOnClick: false,
                offsetY: -10,
                donut: {
                    size: "40px",
                    labels: {
                        show: false,
                    },
                    value: {
                        offsetY: -8, // -8 worked for me
                        color: '#ff00ff'
                    }
                }
            }
        },
        series: values
    }

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(SalesByProduct.current, title, type);
        }
    }

    const exportFile = () => {
        let newHead = [['Name', type === 'value' ? 'Amount' : 'Quantity', 'Percentage']];
        labels.length > 0 && labels.map((data, i) => {
            newHead[i + 1] = [data, values[i], percentage[i]];
        });
        exportChatFile(`${title}`, newHead);
    }


    return (
        <div ref={SalesByProduct}>
            <div className={clsx(classes.totalChartDiv, classes.topProductSupplySales)}>
                <div className={clsx(classes.monthlyDivTitle, classes.bold)}><span>{title}</span>
                    <span className={clsx(classes.monthlyDivTitleFilter)} style={{}}>
                        <RadioGroup
                            row
                            onChange={(e) => handleType(e.target.value)}
                            defaultValue={'value'}>
                            <FormControlLabel value="value" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="Value" />
                            <FormControlLabel value="quantity" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="Quantity" />
                        </RadioGroup>
                    </span>
                    <span className={classes.hamburgerMenuSales}>
                        <Dropdown
                            placement="bottomLeft"
                            trigger={['click']}
                            overlay={
                                <Menu className={clsx(classes.groupMenu)}>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                                </Menu>
                            }>
                            <Image src={hamburgerMenu} preview={false} />
                        </Dropdown>
                    </span>
                </div>
                <div className={clsx(classes.boxBorderInnerProduct)}>
                    {
                        values?.length > 0 && <ReactApexChart options={chartSalesProduct} series={chartSalesProduct.series} type="donut" width="100%" height="100%" />
                    }
                    <div className={clsx(classes.customSalesCount)}>
                        <div className={clsx(classes.customSalesTotalLeft)}>
                            <p className={classes.customSalesTotalText} title={`${subTitle} Sales`}>{subTitle} Sales</p>
                            <p className={clsx(classes.customSalesTotalFont, classes.customSalesTotalFontBig)}
                                title={type === 'value' ? '₹ ' + currencyFormatInt(value) : quantityFormat(quantity)}>
                                {type === 'value' ? '₹ ' + currencyFormatInt(value) : quantityFormat(quantity)}
                            </p>
                        </div>
                        <div className={clsx(classes.customSalesTotalRight)}>
                            <p className={clsx(classes.customSalesTotalText)}><span>Top 10 </span><span className={clsx(classes.customSalesTotalFont)}>{top10}%</span></p>
                            <p className={clsx(classes.customSalesTotalText, classes.customSalesTotalRightTop)}><span>Others</span> <span className={clsx(classes.customSalesTotalFont)}> {(100 - top10).toFixed(1)}%</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}